import IAddressCandidateViewModel from "../AddressCandidateViewModel";
import {BaseIdentifyingInformation } from "../AlacrityInterfaces"

export default class MappingAddressCandidateRequestViewModel {
  private AddressCandidate?: IAddressCandidateViewModel;

  constructor(
    userId: number,
    applicationId: number,
    versionId: string,
    cityName: string,
    countyName: string,
    stateName: string
  ) {
    this.AddressCandidate = {
      cityName,
      countyName,
      stateName
    };
  }

  static new(
    identity: BaseIdentifyingInformation,
    addressCandidate: IAddressCandidateViewModel
  ): MappingAddressCandidateRequestViewModel {
    return new MappingAddressCandidateRequestViewModel(
      identity.userId,
      identity.applicationId,
      identity.versionId,
      addressCandidate.cityName,
      addressCandidate.countyName,
      addressCandidate.stateName
    );
  }
}
